import { request } from '@/utils/request';
import { getStorageSync } from '@/utils/storage.js';

// 账号密码登录
export const doLogin = options => {
	return request({
		url: '/sso/mallLogin',
		method: 'POST',
		data: options,
		header: {
			'content-type': 'application/x-www-form-urlencoded',
		},
	});
};

//获取验证码
export const loginSms = options => {
	return request({
		url: '/user/public/loginSms',
		method: 'POST',
		data: options,
	});
};
//短信登录
export const smsLogin = options => {
	return request({
		url: '/sso/smsLogin',
		method: 'GET',
		data: options,
	});
};

//获取站点
export const getMutil = options => {
	return request({
		url: '/user/public/getMutil',
		method: 'GET',
		data: options,
	});
};

//获取站点
export const getWebsiteInfoNoLogin = options => {
	return request({
		url: '/cms/public/website/queryWebsiteByCompanyId?companyId=' + options,
		method: 'GET',
	});
};

// 主站点搜索商品
export const getAllGoods1 = options => {
	return request({
		url: '/product/public/queryPcProductInfoByPageAndPublic',
		method: 'POST',
		data: options,
	});
};
// 子站登陆用户搜索商品
export const getAllGoods = options => {
	return request({
		url: '/product/mall/queryPcProductInfoByPage',
		method: 'POST',
		data: options,
	});
};
// 子站游客搜索商品
export const getAllGoodsByVisitor = options => {
	return request({
		url: '/product/public/queryPcProductInfoByVisitor',
		method: 'POST',
		data: options,
	});
};
// 子站非站点客户搜索商品
export const getAllGoodsByNoClient = options => {
	return request({
		url: '/product/mall/queryPcProductInfoByNoClient',
		method: 'POST',
		data: options,
	});
};

// 获取商品价格
export const getGoodsPricePre = options => {
	return request({
		url: '/product/mall/queryProductPriceAndCollect',
		method: 'POST',
		data: options,
	});
};

// 获取商品价格
export const queryProductPriceAndCollectByVisitor = options => {
	return request({
		url: '/product/mall/queryProductPriceAndCollectByVisitor',
		method: 'POST',
		data: options,
	});
};

// 分类
export const getMobileCategory = options => {
	return request({
		url: '/product/public/getMobileCategory',
		method: 'POST',
		data: options,
	});
};
// 二级	分类
export const getChildrenMobileCategory = options => {
	return request({
		url: '/product/public/getChildrenMobileCategory',
		method: 'POST',
		data: options,
	});
};

// 获取主站资讯轮播
export const getHotNews = options => {
	return request({
		url: '/cms/public/indexAnnouncement',
		method: 'GET',
		data: options,
	});
};
// 搜索热搜词
export const getHotWordList1 = options => {
	return request({
		url: '/cms/public/hotWords/mainSiteQueryByCompanyId',
		method: 'GET',
	});
};
//获取首页热搜词
export const getHotWordListNoLogin = options => {
	return request({
		url: '/cms/public/hotWords/queryByCompanyId',
		method: 'POST',
		data: options,
	});
};
//获取首页热搜词
export const getHotWordList = options => {
	return request({
		url: '/cms/mall/hotWords/queryByCompanyId',
		method: 'POST',
		data: options,
	});
};
// 获取订单数据
export const queryDemandStatusCountp = options => {
	return request({
		url: '/order/public/queryDemandStatusCount',
		method: 'POST',
		data: options,
	});
};

// 获取所有返利
export const getAllBlance = options => {
	return request({
		url: '/order/public/getAllBlance',
		method: 'GET',
		data: options,
	});
};

// 获取可用优惠券
export const getMyCoupon = options => {
	return request({
		url: '/order/mall/myCoupon',
		method: 'GET',
		data: options,
	});
};
// 获取用户权限
export const getUserSite = options => {
	if (!!getStorageSync('cmdc_access_token_mobile')) {
		return request({
			url: '/user/mall/switchWebsite',
			method: 'POST',
			data: options,
		});
	}
};

// 获取用户站点
export const queryUserWebsite = options => {
	return request({
		url: '/user/mall/queryUserWebsite',
		method: 'GET',
		data: options,
	});
};
// 获取热门站点
export const queryByCompanyIdAndPublishType = options => {
	return request({
		url: '/cms/mall/publish/queryByCompanyIdAndPublishType',
		method: 'POST',
		data: options,
	});
};

// 获取热门站点
export const getIndexContentNoLogin = options => {
	return request({
		url: '/cms/public/publish/queryByCompanyIdAndPublishType',
		method: 'POST',
		data: options,
	});
};

// 获取推送客服的信息
export const getkfDate = options => {
	return request({
		url: '/user/public/getkfDate',
		method: 'POST',
		data: options,
	});
};

/** 国械智造客服 - 根据 companyId 获取 bid（对齐 PC api/gxzz getBidByCompanyId） */
export const getBidByCompanyId = data => {
	return request({
		url: '/user/public/getBidByCompanyId',
		method: 'POST',
		data,
	});
};

// 分享
export const wxShares = options => {
	return request({
		url: '/cms/public/share',
		method: 'GET',
		data: options,
	});
};
//获取验证码
export const getCodeData = options => {
	return request({
		url: '/user/mall/getTelVerifyCode',
		method: 'GET',
		data: options,
	});
};

//更换手机号 step1
export const PhoneNext = options => {
	return request({
		url: '/user/mall/checkTelVerifyCode',
		method: 'POST',
		data: options,
	});
};
//更换手机号 step2
export const updatePhone = options => {
	return request({
		url: '/user/mall/modifyTelephone',
		method: 'POST',
		data: options,
	});
};

//修改密码
export const editPassword = options => {
	return request({
		url: '/user/mall/editPassword',
		method: 'GET',
		data: options,
	});
};

// 获取直通车列表数据
export const getThrough = options => {
	return request({
		url: '/order/public/getThrough',
		method: 'POST',
		data: options,
	});
};

// 获取主站资讯轮播
export const getNoticeList = options => {
	return request({
		url: '/cms/public/information/queryMallPublicPage',
		method: 'POST',
		data: options,
	});
};

// 质量公告
export const getQualityNoticeList = params => {
	return request({
		url: '/cms/public/indexAnnouncement',
		method: 'GET',
		data: params,
	});
};

// 国械头条（国械智造站点头条）
export const gxzzMallQueryPage = params => {
	return request({
		url: '/cms/announcement/public/gxzzMallQueryPage',
		method: 'POST',
		data: params,
	});
};

// 公告详情（新接口）
export const getDetailAnnouncement = params => {
	return request({
		url: '/cms/public/detailAnnouncement',
		method: 'GET',
		data: params,
	});
};

// 获取主站资讯详情
export const getNoticeDetail = options => {
	return request({
		url: '/cms/public/information/queryById',
		method: 'POST',
		data: options,
	});
};

// 获取用户信息
export const queryUserInfo = params => {
	return request({
		url: '/user/mall/queryUserInfo',
		method: 'GET',
		data: params,
	});
};

// 商品详情埋点
export const visitInfo = params => {
	return request({
		url: '/user/public/visitInfo',
		method: 'POST',
		data: params,
	});
};

// 登录和购物车埋点
export const behaviorInfo = params => {
	return request({
		url: '/user/public/behaviorInfo',
		method: 'POST',
		data: params,
	});
};

//获取首页资讯列表
export const getNewsListNoLogin = params => {
	return request({
		url: '/cms/public/information/queryByCompanyId',
		method: 'POST',
		data: params,
	});
};

//获取用户openId
export const wxOpenId = params => {
	return request({
		url: '/cms/public/wx/openId',
		method: 'GET',
		data: params,
	});
};
//退出解绑openId
export const loginOut = params => {
	return request({
		url: '/sso/public/loginOut',
		method: 'GET',
	});
};

//用户注册
export const saveWxUser = params => {
	return request({
		url: '/user/v2/public/registerWxUser',
		method: 'POST',
		data: params,
	});
};

//通过openId获取用户信息
export const userByOpenId = openId => {
	return request({
		url: `/user/public/userByOpenId?openId=` + openId,
		method: 'GET',
	});
};

//通过注册获验证码
export const getSms = params => {
	return request({
		url: '/user/public/getRegisterSms',
		method: 'POST',
		data: params,
	});
};

export const getMobileCategoryFromSearch = data => {
	return request({
		url: '/product/public/queryMobileProductInfoByPageAndPublic',
		method: 'POST',
		data: data,
	});
};

// 国械智造移动端商品列表
export const getGxzzSearchProductList = data => {
	return request({
		url: '/product/public/gxzz/searchProductList',
		method: 'POST',
		data,
	});
};

export const queryJdeConfigByCode = companyId => {
	return request({
		url: `/user/public/queryJdeConfigByCode?companyId=${companyId}`,
		method: 'GET',
	});
};

// 首页栏目图标配置接口
export const selectMobileHomeConfig = size => {
	return request({
		url: `/cms/public/selectMobileHomeConfig?size=${size}`,
		method: 'GET',
	});
};

// 业务埋点
export const statisticsMenu = params => {
	return request({
		url: '/user/statistics/public/statisticsMenu?key=' + params.key + '&uuid=' + params.uuid,
		method: 'GET',
	});
};

// 通过companyId获取站点信息
export const queryWebsiteByCompanyId = params => {
	return request({
		url: '/cms/public/website/queryWebsiteByCompanyId?companyId=' + params,
		method: 'GET',
	});
};

// 通过companyIdNoCode获取站点信息
export const queryWebsiteByCompanyIdNoCode = params => {
	return request({
		url: '/cms/public/website/queryWebsiteByCompanyIdNoCode?companyId=' + params,
		method: 'GET',
	});
};

// 获取盐值
export const getNewIv = params => {
	return request({
		url: `/user/public/encryptStrategySet/getNewIv`,
		method: 'GET',
		params,
	});
};

// 检查用户是否关注公众号
export const subscribe = params => {
	return request({
		url: `/cms/public/wx/subscribe?openId=${params.openId}`,
		method: 'GET',
	});
};

// 获取公众号二维码
export const wxPicUrl = params => {
	return request({
		url: `/cms/public/wx/wxPicUrl?openId=${params.openId}`,
		method: 'GET',
	});
};

//首页-运营品位-查询
export const mbOpSpuQuery = data => {
	return request({
		url: '/product/public/mbOpSpu/query',
		method: 'POST',
		data,
	});
};

//首页-横幅广告
export const getMbBannerAdList = data => {
	return request({
		url: '/product/public/mbBannerAd/getMbBannerAdList',
		method: 'POST',
		data,
	});
};

// 首页-金刚位
export const getMbKingkongAreaList = data => {
	return request({
		url: '/product/public/mbKingkongArea/getMbKingkongAreaList',
		method: 'POST',
		data,
	});
};

// 首页-运营广告
export const getMbOperateAdList = data => {
	return request({
		url: '/product/public/mbOperateAd/getMbOperateAdList',
		method: 'POST',
		data,
	});
};

// 运营广告页-tab列表
export const querySpecialAreaList = data => {
	return request({
		url: '/product/public/mbOperateAd/querySpecialAreaList',
		method: 'POST',
		data,
	});
};

// 运营广告页-商品列表
export const queryProductBySpecialArea = data => {
	return request({
		url: '/product/public/mbOperateAd/queryProductBySpecialArea',
		method: 'POST',
		data,
	});
};

// 获取门户楼层
export const queryFloorByThemeId = data => {
	return request({
		url: '/product/public/homeLayout/queryFloorByThemeId',
		method: 'post',
		data,
	});
};

// 获取品牌列表
export const queryFloorByThemeIdForMb = data => {
	return request({
		url: '/product/public/homeLayout/queryFloorByThemeIdForMb',
		method: 'post',
		data,
	});
};
// 用户绑定手机号
export const bindTelephone = options => {
	return request({
		url: '/user/public/bindTelephone',
		method: 'POST',
		data: options,
	});
};

// 验证手机号是否已注册
export const checkPhoneExists = options => {
	return request({
		url: '/user/public/buyer/merchantPhoneExists',
		method: 'POST',
		data: options,
	});
};

// 修改密码
export const modifyPassword = options => {
	return request({
		url: '/sso/public/modifyPassword',
		method: 'POST',
		data: options,
	});
};

// 用户设置密码修改弹窗不再提醒
export const updatePwdRemindFlag = options => {
	return request({
		url: '/user/public/updatePwdRemindFlag',
		method: 'POST',
		data: options,
	});
};

// 猜你喜欢
export const recommendProducts = data => {
	return request({ url: `/product/public/recommendProducts`, method: 'POST', data });
};

// 国械标讯
export const searchNotice = () => {
	return request({ url: '/user/public/searchNotice', method: 'get' });
};
